const INPUT_SELECTOR = '.t5-input-client';

const OPTION_DEFAULTS = {
    ajax: {
        dataType: 'json',
        delay: 300,
        data: ({ term }) => ({
            query: term,
        }),
    },
    minimumInputLength: 2,
};

const ClientInput = {
    init: ($scope) => {
        if (!$scope) {
            $scope = $(document);
        }

        const $inputs = $scope.find(INPUT_SELECTOR);

        $inputs.each(function () {
            const $input = $(this);
            const options = Object.assign({}, OPTION_DEFAULTS);

            options.ajax.url = $input.data('source');
            options.placeholder = $input.attr('placeholder');

            // https://select2.org/troubleshooting/common-problems#select2-does-not-function-properly-when-i-use-it-inside-a-bootst
            const $modal = $input.closest('.modal');

            if ($modal.length) {
                options.dropdownParent = $modal.find('.modal-body')
                    || $modal.find('.modal-content')
                    || $modal;
            }

            $input.select2(options);
        });
    },
};

export default ClientInput;
